import React from "react";
import { motion } from "framer-motion";

interface FeatureScenarioProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    color: string;
}

const FeatureScenario: React.FC<FeatureScenarioProps> = ({ icon, title, description, color }) => (
    <motion.div
        dir="rtl"
        className="backdrop-blur-sm bg-white/70 p-5 rounded-xl border border-gray-100 shadow-sm h-full flex flex-col"
        whileHover={{
            scale: 1.02,
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
        }}
        transition={{ duration: 0.2 }}
    >
        <div className="flex items-center mb-3">
            <motion.div
                className={`ml-3 w-10 h-10 rounded-full bg-gradient-to-r ${color} flex items-center justify-center text-white shrink-0 [&>svg]:w-5 [&>svg]:h-5 [&>svg]:m-auto`}
                animate={{ rotate: [0, 5, -5, 0] }}
                transition={{ duration: 3, repeat: Infinity }}
            >
                {icon}
            </motion.div>
            <h5 className="text-md font-medium text-gray-800">{title}</h5>
        </div>
        <p className="text-gray-600 text-sm leading-relaxed flex-grow">{description}</p>
    </motion.div>
);

export default FeatureScenario;
